module.exports = __webpack_public_path__ + "img/ic_employee.2bace78d.png";